const getOrder = (column, ordering) => {
  const orderingKey = column.sortBy ? 'sortBy' : 'key';
  if (column[orderingKey] === (ordering && ordering[orderingKey])) {
    return ordering.order;
  }
  return null;
};

const getTableHeaders = (columns, { visibleColumns, withRowActions, ordering }) => {
  const headers = columns
    .map(column => {
      const order = getOrder(column, ordering);

      if (visibleColumns === null || visibleColumns.includes(column.label)) {
        return {
          label: column.label,
          freeze: column.freeze,
          order,
          ...column.header,
        };
      }
    })
    .filter(Boolean);

  if (withRowActions) {
    headers.push('');
  }

  return headers;
};

export default getTableHeaders;
